// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-7fbbe087] .el-dialog__body {\n  padding: 10px 10px;\n  height: 450px;\n  overflow: auto;\n}\n[data-v-7fbbe087] .el-dialog__body .el-select {\n  width: 100%;\n}\n.el-form-item--mini.el-form-item[data-v-7fbbe087] {\n  margin-bottom: 10px;\n}", ""]);
// Exports
module.exports = exports;
